import FieldToggle from "../../../generic/boolean/toggle/toggle"
import FieldConfig from "../../../proto/field-config"
import FieldTimeReportIsBillable_ViewProperty from "./render/property"
import FieldTimeReportIsBillable_TableCell from "./render/table-cell"
import FieldTimeReportIsBillable_ViewGroup from "./render/group"
import ModelEntity from "../../../../model2/model-entity"
import TimeReport from "../../../../model2/time-report/time-report"

export default class FieldTimeReportIsBillable extends FieldToggle {

    constructor(config:FieldConfig) {
        super(config)

        this.icon = 'i5-cash'

        this.isGroupByAvailable = true

        this.renderComponents.viewProperty = FieldTimeReportIsBillable_ViewProperty
        this.renderComponents.tableCell    = FieldTimeReportIsBillable_TableCell
        this.renderComponents.viewGroup    = FieldTimeReportIsBillable_ViewGroup
    }

    canEdit(model: ModelEntity): boolean {
        return gd.modules.timeTracking.isBillableTimeEnabled
            && (model as TimeReport).canEdit
    }

    groupValue(value: any): any {
        return value
    }

    groupLabel(value: any): string {
        if (value)  {
            return 'Billable'
        } else {
            return 'Not Billable'
        }
    }
}